type ProfileProps = {
    registrationDate: Date;
    unregistrationDate: Date;
    lastLoginDate: Date;
    email: string;
    displayName: string;
};

export default class Profile {
    registrationDate: Date;

    unregistrationDate: Date;

    lastLoginDate: Date;

    email: string;

    displayName: string;

    constructor({
        registrationDate,
        unregistrationDate,
        lastLoginDate,
        email,
        displayName,
    }: ProfileProps) {
        this.registrationDate = registrationDate;
        this.unregistrationDate = unregistrationDate;
        this.lastLoginDate = lastLoginDate;
        this.email = email;
        this.displayName = displayName;
    }
}
